const defaultState = {
    history: [],
    loading: false,
    errors:{},
    lastFiltersDIsHidro: ''
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

        case 'FETCH_HISTORY_FULFILLED': {
            return {
            ...state,
            history: action.payload.data,
            loading: false,
            errors: {}
            }
        }
    
        case 'FETCH_HISTORY_PENDING': {
            return {
            ...state,
            loading: true,
            errors: {}
            }
        }
    
        case 'FETCH_HISTORY_REJECTED': {
            return {
            ...state,
            loading: false,
            errors: { global: action.payload.message }
            }
        }

        case 'LASTFILTER_DIs_HIDRO': {
            return {
                ...state,
                lastFiltersDIsHidro: action.payload
            }
          }
        
        default:
            return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/history-hidro-reducer.js